import React, { useCallback, useMemo, useState } from 'react';

import Form from '@rjsf/mui';
import validator from '@rjsf/validator-ajv8';
import { useHistory } from 'react-router-dom';

import { Box, Button } from '@mui/material';

import ReservationService from '../../../services/ReservationService';
import { reportError } from '../../../utils/reportError';
import ErrorListDisplay from '../ErrorListDisplay';

import { buttonMessages, buttonStates } from './states/submitButton';
import CustomSelectFieldWidget from './widgets/CustomSelectFieldWidget';

function RatePlansGroupsForm({ vendorId, schema: baseSchema, ratePlansGroups }) {
  const history = useHistory();

  /** ---------- Build schema only once ---------- */
  const schema = useMemo(() => {
    return {
      ...baseSchema,
      properties: {
        ...baseSchema.properties,
        rate_plans_groups: {
          ...baseSchema.properties.rate_plans_groups,
          items: {
            ...baseSchema.properties.rate_plans_groups.items,
            title: 'Rate plan group',
          },
        },
      },
    };
  }, [baseSchema]);

  const uiSchema = useMemo(() => {
    const enumValues = baseSchema.properties.rate_plans_groups.items.properties.rate_plans.items.enum;
    const enumLabels = baseSchema.properties.rate_plans_groups.items.properties.rate_plans.items.enumNames;

    return {
      rate_plans_groups: {
        'ui:options': { orderable: false },
        items: {
          id: { 'ui:widget': 'hidden' },
          rate_plans: {
            'ui:widget': CustomSelectFieldWidget,
            'ui:options': { enumOptions: enumValues.map((value, index) => ({ value, label: enumLabels[index] })) },
          },
        },
      },
    };
  }, [baseSchema]);

  const [formData, setFormData] = useState({
    rate_plans_groups: ratePlansGroups,
  });
  const [saveState, setSaveState] = useState(buttonStates.default);
  const [errors, setErrors] = useState([]);

  const handleSubmit = useCallback(
    ({ formData }) => {
      setSaveState(buttonStates.saving);
      setFormData(formData);

      ReservationService.updateRatePlansGroups(vendorId, formData)
        .then(() => {
          setSaveState(buttonStates.saved);
          setErrors([]);
          history.push(`/vendors/${vendorId}/rate-plans-groups`);
        })
        .catch((e) => {
          const apiErrors = [];
          if (e.name === 'ValidationError') {
            e.errors.filter((x) => x.path !== 'id_salesforce_external').forEach((err) => apiErrors.push(err.message));
          }
          setSaveState(buttonStates.failed);
          setErrors(apiErrors);
          reportError(e);
        });
    },
    [history, vendorId],
  );

  return (
    <Form schema={schema} uiSchema={uiSchema} formData={formData} validator={validator} onSubmit={handleSubmit}>
      <Box component="div" className="button-container">
        <Button type="submit" variant="contained" className={saveState}>
          {buttonMessages[saveState]}
        </Button>
      </Box>

      {errors.length > 0 && <ErrorListDisplay messages={errors} />}
    </Form>
  );
}

export default RatePlansGroupsForm;
